function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.286 6.857h15.429M8.571 6.857V5.143a1.714 1.714 0 011.715-1.714h3.428a1.714 1.714 0 011.715 1.714v1.714m2.571 0v12a1.714 1.714 0 01-1.714 1.714H7.714A1.714 1.714 0 016 18.857v-12h12zM10.286 11.143v5.143M13.714 11.143v5.143",
  stroke: "#F2F2F2",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgTrashIcon;